import { combineReducers } from 'redux';
import { ActionType, getType } from 'typesafe-actions';

import { AppState, ConfigState, GetGeolocationsState, LogClientInfoState, LookupValuesState, MenuGoBackUrlState, PingState, PMPoliciesState, PoliciesState, PolicyConsentsStatusState } from './Types';

import * as Actions from './Actions';
export type AppAction = ActionType<typeof Actions>;

const pingInitialState: PingState = {
    isCommunicating: false,
    data: {},
    error: false,
};

const policiesInitialState: PoliciesState = {
    isCommunicating: false,
    error: false,
    data: {},
};

const pmpoliciesInitialState: PMPoliciesState = {
    isCommunicating: false,
    error: false,
    data: null,
};

const selectedPolicyConsentStatusInitialState: PolicyConsentsStatusState = {
    isCommunicating: false,
    data: {},
    error: false,
};

const configInitialState: ConfigState = {};

const menuGoBackUrlInitialState: MenuGoBackUrlState = {};

const logClientInfoInitialState: LogClientInfoState = {
    isCommunicating: false,
    error: false,
};

const lookupValuesState: LookupValuesState = {
    isCommunicating: false,
    error: false,
    marcas: [],
    modelos: [],
    versoes: [],
    dealers: [],
    cancelationReasons: [],
    seriesSegments: [],
    districts: [],
};

const getGeolocationsState: GetGeolocationsState = {
    isCommunicating: false,
    error: false,
    geolocations: [],
};

export default combineReducers<AppState, AppAction>({
    ping: (state = pingInitialState, action) => {
        switch (action.type) {
            case getType(Actions.pingRequest):
                return {
                    ...state,
                    isCommunicating: true,
                    data: {},
                };
            case getType(Actions.pingSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: {
                        pingResult: true,
                    },
                    error: false,
                };
            case getType(Actions.pingFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    data: {
                        pingResult: false,
                    },
                    error: true,
                };
            default:
                return state;
        }
    },
    config: (state = configInitialState, action: AppAction) => {
        switch (action.type) {
            case getType(Actions.updateConfig):
                return {
                    config: action.payload,
                };
            default:
                return state;
        }
    },
    menuGoBackUrl: (state = menuGoBackUrlInitialState, action: AppAction) => {
        switch (action.type) {
            case getType(Actions.menuGoBackUrl):
                return {
                    location: action.payload,
                };
            default:
                return state;
        }
    },
    logClientInfo: (state = logClientInfoInitialState, action) => {
        switch (action.type) {
            case getType(Actions.logClientInfoRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.logClientInfoSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    error: false,
                };
            case getType(Actions.logClientInfoFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    selectedPolicyConsent: (state = null, action) => {
        switch (action.type) {
            case getType(Actions.selectPolicyConsent):
                return action.payload;
            default:
                return state;
        }
    },
    selectedPolicyConsentStatus: (state = selectedPolicyConsentStatusInitialState, action) => {
        switch (action.type) {
            case getType(Actions.setPolicyConsentsRequest):
                return {
                    ...state,
                    isCommunicating: true,
                    data: {},
                };
            case getType(Actions.setPolicyConsentsSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: {
                        consentsSaved: true,
                    },
                    error: false,
                };
            case getType(Actions.setPolicyConsentsFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    data: {
                        consentsSaved: false,
                    },
                    error: true,
                };
            default:
                return state;
        }
    },
    lookupValues: (state = lookupValuesState, action) => {
        switch (action.type) {
            case getType(Actions.loadLookupValuesRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.loadLookupValuesSuccess): {
                return {
                    ...state,
                    isCommunicating: false,
                    error: false,
                    ...action.payload,
                    marcas: action.payload.marcas ? action.payload.marcas : [],
                    modelos: action.payload.modelos ? action.payload.modelos : [],
                    dealers: action.payload.dealers ? action.payload.dealers : [],
                    cancelationReasons: action.payload.cancelationReasons ? action.payload.cancelationReasons : [],
                    // seriesSegments: action.payload.seriesSegments ? action.payload.seriesSegments : [],
                    districts: action.payload.districts ? action.payload.districts : [],
                    versoes: action.payload.versoes ? action.payload.versoes : [],
                };
            }
            case getType(Actions.loadLookupValuesFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    getGeolocations: (state = getGeolocationsState, action) => {
        switch (action.type) {
            case getType(Actions.getGeolocationsRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.getGeolocationsSuccess): {
                return {
                    ...state,
                    isCommunicating: false,
                    error: false,
                    ...action.payload,
                    geolocations: action.payload ? action.payload : [],
                };
            }
            case getType(Actions.getGeolocationsFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    policies: (state = policiesInitialState, action) => {
        switch (action.type) {
            case getType(Actions.loadPoliciesRequest):
                return {
                    ...state,
                    isCommunicating: true,
                    data: {},
                };
            case getType(Actions.loadPoliciesSuccess): {
                return {
                    ...state,
                    isCommunicating: false,
                    data: {
                        policies: action.payload,
                    },
                    error: false,
                };
            }
            case getType(Actions.loadPoliciesFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                    data: {},
                };
            default:
                return state;
        }
    },
    pmpolicies: (state = pmpoliciesInitialState, action) => {
        switch (action.type) {
            case getType(Actions.loadPMPoliciesRequest):
                return {
                    ...state,
                    isCommunicating: true,
                    data: null,
                };
            case getType(Actions.loadPMPoliciesSuccess): {
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            }
            case getType(Actions.loadPMPoliciesFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                    data: null,
                };
            default:
                return state;
        }
    },
});
